export default __webpack_public_path__ + "static/media/co.1e14f0f2.svg";